import { Client, ClosureData, Stream } from 'types';

export const getMonthlyReception = (data: ClosureData, client: Client, stream: Stream): number => {
  const clientId = client.id;
  const streamId = stream.id;
  return data.monthlyReceptions?.[clientId]?.[streamId] ?? 0;
};
